export default __webpack_public_path__ + "static/media/ipad-right-img.32ddea48.jpg";